import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addServer, updServer, batchEditServer } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewPage, gmToolNewCom],
  data: function data() {
    return {
      dialogShow: false,
      serverIdList: [],
      checked: false,
      paramsData: {
        serverID: [],
        is_timing: 2,
        time_to_run: '',
        config_state: '',
        OpenTime: '',
        is_test: '',
        new_tag: '',
        is_recomm: '',
        push_msg: '',
        areaID: '',
        ver_max: '',
        ver_min: '',
        serverIP: '',
        serverPort: '',
        mainServer: ''
      },
      newTag: [{
        label: this.$t('yes'),
        value: true
      }, {
        label: this.$t('no'),
        value: false
      }],
      rules: {
        is_timing: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        config_state: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        new_tag: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        is_recomm: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        time_to_run: [{
          required: true,
          message: this.$t('pleaseSelectTime'),
          trigger: "blur"
        }],
        areaID: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        ver_max: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        ver_min: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        serverID: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        serverIP: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        serverPort: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        OpenTime: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }],
        mainServer: [{
          required: true,
          message: this.$t('pleaseSelect'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.paramsData.serverID = [];

      if (this.checked) {
        this.serverIdList.map(function (item) {
          _this.paramsData.serverID.push(item.server_id);
        });
      } else {
        this.paramsData.serverID = [];
      }
    },
    changeSelect: function changeSelect(val) {
      if (val.length === this.serverIdList.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    serverSelect: function serverSelect(val) {
      var selectedItem = this.serverIdList.find(function (item) {
        return item.server_id == val;
      });
      this.paramsData.serverIP = selectedItem.serverIP;
      this.paramsData.serverPort = selectedItem.serverPort;
    },
    open: function open(data) {
      this.dialogShow = true;
      this.serverIdList = JSON.parse(data);
    },
    addtag: function addtag(data) {
      this.paramsData.push_msg = "".concat(this.paramsData.push_msg).concat(data);
    },
    addDomain: function addDomain() {
      this.paramsData.data.push({
        server_id: "",
        server_name: ""
      });
    },
    hiad: function hiad() {
      this.dialogShow = false;
      this.clearData();
    },
    removeDomain: function removeDomain(item) {
      var index = this.ex_Val.indexOf(item);

      if (index !== -1) {
        this.paramsData.data.splice(index, 1);
      }
    },
    clearData: function clearData() {
      this.paramsData = {
        serverID: [],
        is_timing: 2,
        time_to_run: '',
        config_state: '',
        new_tag: '',
        is_test: '',
        areaID: '',
        is_recomm: '',
        push_msg: '',
        ver_max: '',
        ver_min: '',
        OpenTime: '',
        serverIP: '',
        serverPort: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var time_to_run = 0;

          if (_this2.paramsData.time_to_run) {
            var timestamp = new Date().valueOf();
            time_to_run = _this2.paramsData.time_to_run / 1000 - parseInt(timestamp / 1000);

            if (time_to_run <= 0) {
              _this2.$message.error(_this2.$t('scheduledTimeCannotBeLessThanCurrentTime'));

              return;
            }
          }

          var data = {
            serverID: _this2.paramsData.serverID.toString(),
            is_timing: _this2.paramsData.is_timing,
            time_to_run: _this2.paramsData.time_to_run ? _this2.$times.timestampToTime(_this2.paramsData.time_to_run / 1000, "YY-MM-DD hh:mm:ss") : '',
            showTime: _this2.paramsData.time_to_run ? _this2.$times.timestampToTime(_this2.paramsData.time_to_run / 1000, "YY-MM-DD hh:mm:ss") : '',
            state: JSON.stringify(_this2.paramsData.config_state),
            config_state: JSON.stringify(_this2.paramsData.config_state),
            new_tag: _this2.paramsData.serverID ? JSON.stringify(_this2.paramsData.new_tag) : _this2.paramsData.new_tag,
            areaID: _this2.paramsData.areaID,
            is_recomm: JSON.stringify(_this2.paramsData.is_recomm),
            ver_min: _this2.paramsData.ver_min,
            ver_max: _this2.paramsData.ver_max,
            push_msg: _this2.paramsData.push_msg,
            OpenTime: _this2.paramsData.OpenTime ? _this2.$times.timestampToTime(_this2.paramsData.OpenTime / 1000, "YY-MM-DD hh:mm:ss") : '',
            game_id: _this2.rawData.game_id,
            serverIP: _this2.paramsData.serverIP,
            serverPort: _this2.paramsData.serverPort
          };
          batchEditServer(_objectSpread(_objectSpread({}, data), _this2.propsData)).then(function (res) {
            if (res.code == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('update');
            }
          });
        }
      });
    },
    textareaChange: function textareaChange() {
      var code = this.paramsData.textarea.split(/[(\r\n)\r\n]+/);
      var serList = [];
      code.forEach(function (item) {
        var d = item.split(",");
        serList.push({
          server_id: d[0],
          server_name: d[1]
        });
      });
    }
  }
};